// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d615b93f","453":"b3f3d769","455":"54f8dded"}[chunkId] + ".chunk.js";
};